import { Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import {
  PurposeCodeSettings,
  PurposeCodeSettingsFormValues,
} from '../../types';

export const purposeCodesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPurposeCodesSettings: build.query<Response<PurposeCodeSettings>, void>({
      query: () => ({
        url: '/v1/purpose-code-settings?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPurposeCodesSettingsById: build.query<
      { data: PurposeCodeSettings },
      string
    >({
      query: (id) => ({
        url: `/v1/purpose-code-settings/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createPurposeCodeSetting: build.mutation<
      { data: PurposeCodeSettings },
      PurposeCodeSettingsFormValues
    >({
      query: (body) => ({
        url: '/v1/purpose-code-settings',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updatePurposeCodeSetting: build.mutation<
      { data: PurposeCodeSettings },
      PurposeCodeSettings
    >({
      query: (body) => ({
        url: `/v1/purpose-code-settings/${body.id}`,
        method: 'PUT',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    deletePurposeCodeSetting: build.mutation<
      { data: PurposeCodeSettings },
      string
    >({
      query: (id) => ({
        url: `/v1/purpose-code-settings/${id}`,
        method: 'DELETE',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetPurposeCodesSettingsByIdQuery,
  useLazyGetPurposeCodesSettingsQuery,
  useCreatePurposeCodeSettingMutation,
  useUpdatePurposeCodeSettingMutation,
  useDeletePurposeCodeSettingMutation,
} = purposeCodesApi;

export const {
  endpoints: {
    getPurposeCodesSettings,
    getPurposeCodesSettingsById,
    updatePurposeCodeSetting,
    createPurposeCodeSetting,
    deletePurposeCodeSetting,
  },
} = purposeCodesApi;
